import React from 'react'
import { NavLink } from 'react-router-dom'


const ListItemX2 = props => {

	const {
		label,
		to,
		value
	} = props

	if (to) {
		return (
			<NavLink className="list_item_x2" to={to}>
				<h6 className="_label">{label}</h6>
				<span className="_value">{value}</span>
			</NavLink>
		)
	}

	return (
		<div className="list_item_x2">
			<h6 className="_label">{label}</h6>
			<span className="_value">{value}</span>
		</div>
	)

}


export default ListItemX2
